const jobsNavigationEl = document.querySelector('.jobs-navigation');

export default function() {
  if (jobsNavigationEl) {
    function onFormElVisibility(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          jobsNavigationEl.classList.add('hidden');
        } else {
          jobsNavigationEl.classList.remove('hidden');
        }
      });
    }

    function observeCompactFormEl() {
      const compactFormElement = document.querySelector('.page-footer');

      if (!compactFormElement) {
        return;
      }

      const observer = new IntersectionObserver(onFormElVisibility, {
        threshold: 0, // 0 means the callback is invoked as soon as even one pixel is visible
      });

      observer.observe(compactFormElement);
    }

    document.addEventListener('DOMContentLoaded', observeCompactFormEl);
  }
}
